let skills = [
  {
    name: "HTML",
    years: 4,
  },
  {
    name: "CSS",
    years: 4,
  },
  {
    name: "Javascript",
    years: 4,
  },
  {
    name: "Accessibility",
    years: 4,
  },
  {
    name: "React",
    years: 3,
  },
  {
    name: "Sass",
    years: 3,
  },
];

export default skills;
